import {isNullOrUndefined} from "../../../services/Validator";
import {kSystemIcons} from "../../../constants/icons";

export default function BrevetFiltersGradeSelection({availableGrades, draftGrades, handleToggleGrade}) {
    // Used in

    // BUILD
    if (isNullOrUndefined(availableGrades) || isNullOrUndefined(draftGrades))
        return null
    return (
        <div className={"mt-[24px] w-full flex flex-col space-y-[8px]"}>
            <span className={"text-white text-[14px] font-bold"}>
                {"Niveau"}
            </span>
            <div className={"flex flex-col space-y-[8px]"}>
                {availableGrades.map((grade, index) => (
                    <div key={index}
                         className={"cursor-pointer flex justify-start items-center space-x-[12px]"}
                         onClick={() => handleToggleGrade(grade)}>
                        <div className={`w-[20px] min-w-[20px] h-[20px] min-h-[20px] border-1 ${isItemChecked(grade) ? "border-greenStar bg-greenStar" : "border-greyLight9"} rounded-[2px] flex justify-center items-center`}>
                            {isItemChecked(grade)
                                ? <i className={`material-icons text-[16px] text-primaryDark7`}>
                                    {kSystemIcons.check}
                                  </i>
                                : null}
                        </div>
                        <span className={'font-normal text-white text-[14px]'}>
                            {grade}
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );

    // METHODS
    // ---- LOGIC : Check if appliedGrades is in a
    function isItemChecked(item) {
        return draftGrades.includes(item)
    }
}